import { useAuth } from '../../../hooks/useAuth';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { ADMIN_STEP_UP_VERIFY_PATH } from '../../../constants/adminStepUp';

export const PrivateAdminRoute: React.FC = () => {
  const { isAuthenticated, account } = useAuth();
  const location = useLocation();

  if (!(isAuthenticated && account?.isAdmin)) {
    return <Navigate to="/signin" />;
  }

  const isVerifyPage = location.pathname === ADMIN_STEP_UP_VERIFY_PATH;
  // 確認コード未検証（または管理者モードの期限切れ）なら確認画面へ
  if (account.adminStepUpRequired && !isVerifyPage) {
    return <Navigate to={ADMIN_STEP_UP_VERIFY_PATH} replace />;
  }
  // 確認不要なのに確認画面にいる場合は管理画面へ戻す
  if (!account.adminStepUpRequired && isVerifyPage) {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
};
